import path from 'path'
import { SUB_SEPARATOR } from '../selectors/dataset'

const FORBIDDEN_PREFIXES = [
  'block',
  'tomoSlice',
  'segmentedSlice',
  'distance_mapSlice',
  'labelsSlice'
]

export function isDatasetPath (filepath) {
  if (!filepath) return false
  if (!(filepath.endsWith('.nc') || filepath.endsWith('_nc') || filepath.endsWith('.nc.bz2'))) {
    return false
  }
  const name = path.basename(filepath)
  return FORBIDDEN_PREFIXES.every((prefix) => {
    return !name.startsWith(prefix)
  })
}

/**
 * Extract path & group from attributes.source.path
 */

export function getArchivePathInfo (sourcePath) {
  if (typeof sourcePath !== 'string' || !sourcePath.length) throw new Error(`sourcePath must not be non-empty string, got ${sourcePath} (${typeof sourcePath})`)
  // strip off leading group name
  const [ group, ...pathSegments ] = sourcePath.split('/')
  return {
    group,
    path: pathSegments.join('/')
  }
}

/**
 * Extract sample/subsample + dataset values from attributes.source
 */

export function sourceToDataset (source) {
  return Object.assign({}, source, {
    group: source.group || 'local',
    sample: findSubsample(source),
    dataset: path.basename(source.path)
  })
}

/**
 * Extract sample/subsample/subsample2 from from attributes.source
 */

export function findSubsample (source) {
  const segments = path.dirname(source.path)
    .split('/')
    .filter(Boolean)
  return segments
    .slice(segments.indexOf(source.sample))
    .join(SUB_SEPARATOR)
}



// WEBPACK FOOTER //
// ../webmango-core/lib/file.js